import { FC, useEffect, useRef } from "react";
import { InputProps } from "@chakra-ui/input";
import { Flex, Input, Text } from "@chakra-ui/react";

interface Props extends InputProps {
  placeholder: string;
  currency?: {
    padding?: string;
    margin?: string;
  };
}

export const InputWithCurrency: FC<Props> = (props) => {
  const {
    placeholder,
    currency,
    ...otherProps
  } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!inputRef.current) return;

    const inputStyle = window.getComputedStyle(inputRef.current);

    const span = document.createElement("span");
    span.style.visibility = "hidden";
    span.style.position = "absolute";
    span.style.whiteSpace = "pre";

    span.style.font = inputStyle.font;
    span.style.letterSpacing = inputStyle.letterSpacing;
    span.style.wordSpacing = inputStyle.wordSpacing;
    span.style.textTransform = inputStyle.textTransform;
    span.style.fontKerning = inputStyle.fontKerning;
    span.style.fontFeatureSettings = inputStyle.fontFeatureSettings;
    span.style.fontVariant = inputStyle.fontVariant;

    span.textContent = placeholder;
    document.body.appendChild(span);
    const placeholderWidth = span.getBoundingClientRect().width;
    document.body.removeChild(span);

    span.textContent = otherProps.value as string | undefined ?? null;
    document.body.appendChild(span);
    const valueWidth = span.getBoundingClientRect().width;
    document.body.removeChild(span);

    inputRef.current.style.width = valueWidth ? `${valueWidth}px` : `${placeholderWidth}px`;
  }, [otherProps.value]);

  return (
    <Flex h="100%" alignItems="center" onClick={() => inputRef.current?.focus()}>
      <Input
        h="100%"
        ref={inputRef}
        borderRadius="none"
        placeholder={placeholder}
        _placeholder={{ color: "gray.400", fontSize: "12px" }}
        padding={!otherProps.value ? "0 0 5px 0" : ""}
        {...otherProps}
        variant="unstyled" // works correctly only with "unstyled" variant
      />

      {otherProps.value && (
        <Text
          pointerEvents="none"
          color={otherProps.color}
          fontSize={otherProps.fontSize}
          padding={currency?.padding ?? "1px 0 0 0"}
          margin={currency?.margin ?? "0 0 0 0"}
        >
          ₽
        </Text>
      )}
    </Flex>
  );
};
